import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import color_prediction from "../features/games/color_prediction/Slice";


const games = combineReducers({
    color_prediction: color_prediction,
});

export default games;